import EventBus from "../EventBus";

export const pagination = {

    data() {
        return {
        }
    },
    methods: {
        handleSizeChange(val) {
            console.log(`${val} items per page`);

            this.searchParams.pagination = val
            // console.log(this.searchParams.start)
            console.log('pagination ' + this.searchParams.pagination)
            this.searchParams.top = this.searchParams.pagination;
            // this.searchParams.skip = (val - 1) * this.searchParams.pagination;
            console.log('top ' + this.searchParams.top)
            console.log('skip ' + this.searchParams.skip)
            this.resultsPerPage()
        },
        handleCurrentChange(val) {
            this.searchParams.currentPage = val
            console.log(`current page: ${val}`);
            console.log('pagination ' + this.searchParams.pagination)

            // this.searchParams.start = (val - 1) * this.searchParams.pagination + 1;
            // console.log(this.$parent.start)
            this.searchParams.skip = (val - 1) * this.searchParams.pagination;
            console.log('top ' + this.searchParams.top)
            console.log('skip ' + this.searchParams.skip)
            this.resultsPerPage()
        },
    }
}